import { render, staticRenderFns } from "./Begin.vue?vue&type=template&id=046a1d24&scoped=true&"
import script from "./Begin.vue?vue&type=script&lang=js&"
export * from "./Begin.vue?vue&type=script&lang=js&"
import style0 from "./Begin.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Begin.vue?vue&type=style&index=1&id=046a1d24&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046a1d24",
  null
  
)

export default component.exports